module.exports = __webpack_public_path__ + "img/wallet-pay-active.87a7f87a.png";